import axios from "axios";

export default {
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.content 
     * @param {String} obj.parentId 
     * @param {String} obj.classify - STUDY_EPISODE
     * @param {String} obj.clssifyforId - 单集id
     */
    submit(obj) {
        return axios.post("/c/Comment/submit", obj);
    },
    getScoreConfig() {
        return axios.get("/course/Study/getScoreConfig");
    },
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.classify 
     * @param {String} obj.clssifyforId - 单集id
     */
    getList(obj) {
        return axios.post("/c/Comment/getList", obj);
    },
    /**
     * 
     * @param {Object} obj 
     * @param {string} obj.episodeId
     */
    getMySumbitScore(obj) {
        return axios.post("/course/Study/getMySumbitScore", obj);
    },
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.id 
     */
    likeComment(obj) {
        return axios.post("/c/Comment/likeComment", obj);
    },

}